exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".firstStart[data-v-567d0dca]{height:100%;display:flex;flex-direction:column;justify-content:space-between}.marginBottom[data-v-567d0dca]{margin-bottom:32px}.image[data-v-567d0dca]{display:inline-block;margin-bottom:12px;transition:all .2s;opacity:1}.image[data-v-567d0dca]:hover{opacity:.8}.image[data-v-567d0dca]:active{transform:scale3d(.98,.98,.98)}@media screen and (max-width:1279px){.cookies[data-v-567d0dca]{font-size:14px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-567d0dca","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?indentedSyntax!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/templates/components/right-menu/ui/mobileApp.vue
// module id = 535
// module chunks = 0